// Gravacao de audio do painel com o MediaRecorder nativo do navegador.
//
// O `mic-recorder-to-mp3` codifica o MP3 na thread principal: quando a aba
// engasga, blocos inteiros se perdem e o audio sai picotado. O buffer maior
// (audioRecorderBufferFix) resolveu para a maioria, mas nao para maquinas mais
// carregadas (Lokos, tkt 60584, 27/10/2026: os audios de uma atendente com
// 3-6 clicks/s, os de outra limpos, mesmo bundle).
//
// O MediaRecorder grava fora da thread principal, entao nao perde blocos. Sai
// em webm/opus (Chrome), ogg/opus (Firefox) ou mp4 (Safari); o backend ja
// transcodifica todo `audio/*` para ogg/opus antes de enviar ao WhatsApp.
//
// Se o navegador nao tiver MediaRecorder, quem chama cai no MicRecorder.

const CANDIDATES = [
  { mime: "audio/webm;codecs=opus", ext: "webm" },
  { mime: "audio/ogg;codecs=opus", ext: "ogg" },
  { mime: "audio/webm", ext: "webm" },
  { mime: "audio/mp4", ext: "m4a" },
];

const pickFormat = () => {
  if (typeof window === "undefined" || !window.MediaRecorder) return null;
  const isSupported = window.MediaRecorder.isTypeSupported;
  if (typeof isSupported !== "function") return null;
  return CANDIDATES.find((c) => isSupported.call(window.MediaRecorder, c.mime)) || null;
};

export const isNativeRecorderAvailable = () => pickFormat() !== null;

export const createNativeRecorder = () => {
  let recorder = null;
  let chunks = [];
  let format = null;

  const start = (stream) => {
    format = pickFormat();
    if (!format) throw new Error("MediaRecorder indisponivel");
    chunks = [];
    recorder = new window.MediaRecorder(stream, {
      mimeType: format.mime,
      audioBitsPerSecond: 64000,
    });
    recorder.ondataavailable = (e) => {
      if (e.data && e.data.size > 0) chunks.push(e.data);
    };
    // timeslice: entrega pedacos a cada 1 s, nao perde tudo se algo falhar no fim
    recorder.start(1000);
  };

  // Resolve com { blob, ext }; o mimetype do blob vai sem o ";codecs=..."
  const stop = () =>
    new Promise((resolve, reject) => {
      if (!recorder || recorder.state === "inactive") {
        reject(new Error("Gravacao nao iniciada"));
        return;
      }
      recorder.onstop = () => {
        const type = format.mime.split(";")[0];
        resolve({ blob: new Blob(chunks, { type }), ext: format.ext });
        recorder = null;
        chunks = [];
      };
      recorder.onerror = (e) => reject(e.error || e);
      recorder.stop();
    });

  const isActive = () => !!recorder && recorder.state !== "inactive";

  return { start, stop, isActive };
};
